import React, {useState} from "react";
import PropTypes from "prop-types";
import Button from "../../../common/Button";

export const FileInput = ({input, className}) => {
  delete input.value;

  const [label, setLabel] = useState(`Загрузить...`);
  const getLabel = (number) => {
    if (number >= 10 && number <= 20) {
      return `${number} файлов`;
    } else if (`${number}`.slice(-1) <= 4 && `${number}`.slice(-1) > 1) {
      return `${number} файла`;
    } else if (`${number}`.slice(-1) === `1`) {
      return `${number} файл`;
    } else {
      return `${number} файлов`;
    }
  };
  return (
    <label>
      <input
        type="file"
        {...input}
        style={{display: `none`}}
        onChange={(e) => {
          input.onChange(e);
          const numberOfFiles = e.target.files.length;
          setLabel(getLabel(numberOfFiles));
        }}
      />
      <Button
        variant="contained"
        style="secondary"
        className={className}
        component="span"
      >
        {label}
      </Button>
    </label>
  );
};

FileInput.propTypes = {
  input: PropTypes.object,
  className: PropTypes.string
};

export default FileInput;
